<style lang="less">
    @import "assets/normalize.less";
    @import "assets/vars.less";
    @import "assets/main.less";
</style>

<style scoped lang="less">
    @import "assets/vars.less";

    .header, .footer {
        position: fixed;
        left: 0;
        z-index: 1000;
        height: 70px;
        padding: 0 70px;

        width: 100%;
        box-sizing: border-box;

        background: @white;

        display: flex;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 1000px) {
            height: 50px;
            padding: 0 50px;
        }

        @media (max-width: 700px) {
            height: 50px;
            padding: 0 30px;
        }
    }

    .header {
        top: 0;

        &_logo {
            a {
                text-decoration: none;
            }
            h2 {
                text-transform: uppercase;
                color: @dark;
                font-weight: 400;
                line-height: 1;
                font-size: 20px;
                letter-spacing: 3px;

                @media (max-width: 1000px) {
                    font-size: 16px;
                }
            }
        }

        &_links {
            min-width: 70%;
            text-align: right;
            .open_btn {
                display: none;
                cursor: pointer;
                > img {
                    width: 25px;
                }
            }

            @media (max-width: 1050px) {
                min-width: 80%;
            }

            @media (max-width: 700px) {
                min-width: 50px;
                .open_btn {
                    display: block;
                }

                .burger {
                    /*display: none;*/
                    display: block;
                    position: absolute;
                    background: @white;
                    left: 0;
                    padding-left: 30px;
                    text-align: left;
                    width: 100%;
                    top: 34px;
                    border-bottom: 1px solid @dark_gray;
                    padding-bottom: 10px;
                    transform: translateY(-50%);
                    opacity: 0;
                    transition: all .5s;
                    pointer-events: none;
                    &.active {
                        pointer-events: all;
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            }

        }
    }

    .main {
        margin: 70px;
        background: @light;
        min-height: calc(~"100vh - 140px");
        @media (max-width: 1000px) {
            margin: 50px;
        }
        @media (max-width: 700px) {
            margin: 50px 30px 85px;
        }
    }

    .footer {
        bottom: 0;
        font-size: 10px;
        &_copy {
            p {
                font-size: 10px;
            }
        }

        @media (max-width: 700px) {
            flex-wrap: wrap;
            flex-direction: column-reverse;
            height: 85px;
            font-size: 10px;
            .ul_menu {
                justify-content: center;
            }
            > div {
                text-align: center;
            }
        }
    }
</style>

<template>
    <div id="app">

        <header class="header">
            <div class="header_logo">
                <router-link to="/"><h2>Евгений Меркулов</h2></router-link>
            </div>
            <div class="header_links">
                <div class="open_btn" @click="openMenu = !openMenu">
                    <img src="icons/menu.svg" alt="">
                </div>
                <ul class="ul_menu burger" :class="{'active': openMenu}">
                    <li @click="openMenu = false">
                        <router-link to="/">Главная</router-link>
                    </li>
                    <li @click="openMenu = false">
                        <router-link to="/albums">Портфолио</router-link>
                    </li>
                    <li @click="openMenu = false">
                        <router-link to="/services">Услуги</router-link>
                    </li>
                    <li @click="openMenu = false">
                        <router-link to="/about">Обо мне</router-link>
                    </li>
                    <li class="margin_left"><a class="bold" href="tel:79042893437">+7&nbsp;(904)&nbsp;289-34-37</a></li>
                </ul>
            </div>
        </header>

        <main class="main">
            <router-view></router-view>
        </main>

        <footer class="footer">
            <div class="footer_copy">
                <p>Фотограф Евгений Меркулов | Разработка сайта – <a class="black_link"
                                                                                         href="http://krupnov.work/"
                                                                                         target="_blank">krupnov.work</a>
                </p>
            </div>
            <div class="footer_menu">
                <ul class="ul_menu">
                    <li><a href="https://vk.com/lip_mafia" target="_blank">ВКонтакте</a></li>
                    <li><a href="https://www.instagram.com/paparazzi48.ru/" target="_blank">Instagram</a></li>
                    <li><a href="https://web.telegram.org/#/im?p=u147301837_405991409219565837" target="_blank">Telegram</a></li>
                    <li><a href="viber://add?number=79042893437" target="_blank">Viber</a></li>
                    <li><a href="https://wa.me/79042893437" target="_blank">WhatsApp</a></li>
                </ul>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data () {
            return {
                openMenu: false,
            };
        },
        methods: {},
    };
</script>